'use client';

import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Button } from '@/components/ui/button/button.component';
import { Icon } from '@/components/ui/icon.component';
import { Sheet, SheetClose, SheetContent, SheetHeader } from '@/components/ui/sheet';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';

const TITLE = 'Atenção!';
const DESCRIPTION = 'Identificamos que o local de atendimento é diferente da sua cidade cadastrada. '
  + 'Consultas presenciais não podem ser convertidas em teleconsulta após o pagamento. Deseja continuar?';

interface DifferentCityConfirmationModalProps {
  open: boolean;
  onAccept: () => void;
  onCancel: () => void;
}

export function DifferentCityConfirmationModal({
  open,
  onAccept,
  onCancel,
}: DifferentCityConfirmationModalProps) {
  const handleOpenChange = (nextOpen: boolean) => {
    if (!nextOpen) {
      onCancel();
    }
  };

  return (
    <Sheet open={open} onOpenChange={handleOpenChange}>
      <SheetContent
        data-testid={DataTestIdEnum.CART_DIFFERENT_CITY_MODAL}
        side="centerFit"
        hasHeader
        title={TITLE}
        description={DESCRIPTION}
        className="p-0 sm:max-w-[25rem] md:bg-transparent border-none overflow-x-hidden"
      >
        <SheetHeader className="bg-white">
          <div className="flex justify-end p-6 pb-0">
            <SheetClose
              data-testid={DataTestIdEnum.CART_DIFFERENT_CITY_MODAL_CLOSE_BUTTON}
              asChild
              className="text-gray-500 cursor-pointer px-2 hover:bg-gray-50"
            >
              <button type="button" aria-label="Fechar">
                <Icon icon={faTimes} size="xl" className="text-[1.625rem] hover:text-gray-900" />
              </button>
            </SheetClose>
          </div>
        </SheetHeader>

        <div className="flex flex-col bg-white px-6 pb-6 pt-2">
          <Typography
            variant={TypographyVariant.MODAL_TITLE}
            data-testid={DataTestIdEnum.CART_DIFFERENT_CITY_MODAL_TITLE}
          >
            {TITLE}
          </Typography>

          <Typography
            className="mt-3 text-gray-700"
            data-testid={DataTestIdEnum.CART_DIFFERENT_CITY_MODAL_DESCRIPTION}
          >
            {DESCRIPTION}
          </Typography>

          <div className="mt-7 flex flex-col gap-4">
            <Button
              data-testid={DataTestIdEnum.CART_DIFFERENT_CITY_MODAL_CONFIRM_BUTTON}
              onClick={onAccept}
            >
              Estou ciente
            </Button>

            <Button
              variant="secondary"
              data-testid={DataTestIdEnum.CART_DIFFERENT_CITY_MODAL_CANCEL_BUTTON}
              onClick={onCancel}
            >
              Cancelar
            </Button>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
}
